import { useEffect, useRef, useState } from "react";
import BarcodeReaderComponent from "../../components/BarcodeReader";
import { useDrawerContext } from "../../context/drawerContext";
import { useNavigate } from "react-router-dom";
import { useHeaderContext } from "../../context/headerContext";
import Button from "../../components/Button";
import CloseIcon from "/public/images/icons/close.svg?react";

export default function BookingsScan() {
  const navigate = useNavigate();
  const { setOpen, setDrawerContent } = useDrawerContext();
  const { setTitle, setBackButton } = useHeaderContext();
  const [isInitialised, setIsInitialised] = useState(false);
  const scanningRef = useRef(false);
  const cameraRef = useRef(null);

  useEffect(() => {
    return () => {
      cameraRef.current?.destroy();
    };
  }, []);

  useEffect(() => {
    setTitle("Scan Booking");
    setBackButton(true);
  }, []);

  useEffect(() => {
    if (!isInitialised) return;
    setOpen(true);
    setDrawerContent(
      <div className="w-full scan-drawer">
        <div className="flex items-center justify-between w-full">
          <br />
          <h2 className="leading-5 tracking-widest uppercase text-[12px]">Scan Booking</h2>
          <CloseIcon className="cursor-pointer" onClick={() => setOpen(false)} />
        </div>
        <div className="mt-6 flex flex-col gap-2 justify-stretch">
          <h3 className="text-[24px]">Point your camera at a booking QR code</h3>
          <p className="text-sportsDarkGrey">The booking details will load automatically once the code is detected.</p>
        </div>
      </div>
    );
  }, [isInitialised]);

  function finishScanning(detections) {
    if (scanningRef.current) return;
    scanningRef.current = true;

    const raw = detections[0].data;
    setOpen(false);

    // Extract the booking ID from the QR payload — it may be a full URL
    // e.g. https://app.sportsguardian.com/bookings/c1bad5b7-... or just the UUID itself
    let bookingId = raw;
    try {
      const url = new URL(raw);
      const parts = url.pathname.split("/").filter(Boolean);
      bookingId = parts[parts.length - 1];
    } catch {
      // raw value is not a URL — treat it as the booking ID directly
    }

    if (!bookingId) {
      showError("Could not read a booking from that code. Please try again.");
      scanningRef.current = false;
      return;
    }

    cameraRef.current?.destroy().finally(() => navigate(`/bookings/${bookingId}`, { replace: true }));
    scanningRef.current = false;
  }

  function showError(message) {
    setOpen(true);
    setDrawerContent(
      <div className="w-full scan-drawer">
        <div className="flex items-center justify-between w-full">
          <br />
          <h2 className="leading-5 tracking-widest uppercase text-[12px]">Error</h2>
          <CloseIcon className="cursor-pointer" onClick={() => setOpen(false)} />
        </div>
        <div className="mt-6 flex flex-col gap-2 justify-stretch">
          <h3 className="text-[24px]">Booking not found</h3>
          <p className="text-sportsDarkGrey">{message}</p>
          <Button variant="quaternary" onClick={() => setOpen(false)}>Close</Button>
        </div>
      </div>
    );
  }

  function onDetected(detections) {
    sessionStorage.setItem("lastCodeScanned", detections[0].data);
    finishScanning(detections);
  }

  return (
    <BarcodeReaderComponent ref={cameraRef} pageSetIsInitialised={() => setIsInitialised(true)} onDetected={onDetected} />
  );
}
